<template>
  <div>
    <!-- This component now acts as a simple router outlet since navigation is handled by Settings.vue -->
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'Config',
  mounted () {
    // Emit initial title to parent
    this.$emit('parent-title', this.$t('setting.name'))
  }
}
</script>

<style scoped>
/* Styles moved to Settings.vue for consistency */
</style>
